import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const GridIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M3 2a1 1 0 0 0-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1H3Zm1 7V4h5v5H4Zm10-7a1 1 0 0 0-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-7Zm1 7V4h5v5h-5Zm-2 5c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-7a1 1 0 0 1-1-1v-7Zm2 1v5h5v-5h-5ZM3 13a1 1 0 0 0-1 1v7c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-7c0-.6-.4-1-1-1H3Zm1 7v-5h5v5H4Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default GridIcon;
